import React, { useEffect, useState, useContext, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { CircularProgress, Stack, ListItem } from "@mui/material";
import { AppendixList } from "../modal";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { DisplayAppendixContent } from "./DisplayAppendixContent";
import { useUserContext } from "../../../context/auth/UserContext";
import { useRiskManagementContext } from "../../../context/RiskManagement/RiskManagementContext";
import { fetchAppendixList } from "./helper";
import { convertToDateMonthFormat } from "../../../utils/ConvertDate";
import CSDataTable from "../../../components/CSDataTable";
import { CSDataTableColumns } from "../../../modal/CSDataTable";
import { AppendixImport } from "./AppendixImport";
import { useAccessRights } from "../../../utils/useAccessRights";

export const Appendix = () => {
  const navigate = useNavigate();
  const riskManagementPageAccess = useAccessRights("Risk Management - CS & SC");

  const [appendixList, setAppendixList] = useState<AppendixList[]>([]);
  const [openAppendixImport, setOpenAppendixImport] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openImportDialog: false,
    openSuccessDialogBox: false,
  });

  const { userId } = useUserContext();
  const {
    selectedRiskManagement,
    setSelectedAppendix,
    setAppendixDetails,
    tabValue,
  } = useRiskManagementContext();

  const displayRiskManagement = () => {
    navigate("/risk-management");
    setAppendixDetails({});
    setSelectedAppendix(null);
  };

  const displayAppendixForm = () => {
    sessionStorage.setItem("allowAppendixForm", "true");
    navigate("/risk-management-appendix-form");
    setAppendixDetails({});
  };

  const handleSelectRow = (selectedRows: any[]) => {
    setSelectedAppendix(selectedRows[0]);
  };

  const handleAppendixImport = () => {
    setOpenAppendixImport(true);
  };

  const handleAppendixImportCancel = () => {
    setAppendixDetails({});
    setOpenAppendixImport(false);
  };

  const fetchTableData = async () => {
    setIsLoading(true);
    try {
      const res = await fetchAppendixList(
        tabValue === 0,
        tabValue === 0
          ? selectedRiskManagement?.csRiskManagementPlanID
          : selectedRiskManagement?.supplyChainPlanID
      );
      if (res) {
        const list = res.map((ele: any) => ({
          ...ele,
          rowId:
            tabValue === 0
              ? ele.csRiskManagementPlanAppendixID
              : ele.scRiskManagementPlanAppendixID,
          approvedDate: convertToDateMonthFormat(ele.approvedDate),
        }));
        setAppendixList(list);
        setIsLoading(false);
      }
    } catch (error) {
      // console.log("@@Error:", error);
    }
  };

  const columns: CSDataTableColumns[] = [
    {
      accessorKey: "title",
      header: "Appendix Name",
      size: "200px",
    },
    {
      accessorKey: "status",
      header: "Status",
      size: "60px",
    },
    {
      accessorKey: "approvedDate",
      header: "Approved",
      size: "80px",
    },
  ];

  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <Fragment>
      <Grid container sx={{ height: "100%", width: "100%" }}>
        <Grid
          xs={6}
          style={{
            padding: "1rem",
            margin: "1rem 0",
            background: "#FFF",
            borderRadius: "2%",
          }}
        >
          <Stack
            direction="row"
            width="100%"
            spacing={1}
            justifyContent="space-between"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton onClick={displayRiskManagement}>
                <ArrowBackIcon />
              </IconButton>

              <Typography
                sx={{
                  color: "#292D32",
                  fontSize: "15px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "normal",
                }}
              >
                Appendix
              </Typography>
            </div>

            <div>
              <Button
                size="small"
                variant="contained"
                className="table-btn"
                onClick={displayAppendixForm}
                disabled={!riskManagementPageAccess?.isCreate || isLoading}
              >
                Create
              </Button>
              <Button
                size="small"
                variant="contained"
                className="table-btn"
                onClick={handleAppendixImport}
                disabled={!riskManagementPageAccess?.isImport || isLoading}
              >
                Import
              </Button>
            </div>
          </Stack>
          {isLoading ? (
            <ListItem
              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
            >
              <CircularProgress />
            </ListItem>
          ) : (
            <CSDataTable
              rows={appendixList}
              columns={columns}
              // previewRecord={appendixList[0]}
              multiRowSelection={false}
              handleSelectRow={(selectedRows) => handleSelectRow(selectedRows)}
            />
          )}
        </Grid>
        <Grid
          xs
          style={{
            padding: "1rem",
            margin: "1rem",
            background: "#FFF",
            borderRadius: "2%",
          }}
        >
          <DisplayAppendixContent refreshList={fetchTableData} />
        </Grid>
      </Grid>
      {
        <AppendixImport
          openDialog={openAppendixImport}
          tableData={appendixList}
          handleCancel={handleAppendixImportCancel}
          refreshList={fetchTableData}
        />
      }
    </Fragment>
  );
};
